// Confete (DESIGN §5.22): 24 paralelogramos 6×14 (o corte de 55°) em tinta, marca e sobre-tinta-2,
// caem do topo em 900 ms, uma vez. Só na celebração do treino e no fim de temporada com pódio.
// `data-confete` some com movimento reduzido (tratado nos tokens).
import { useMemo, type CSSProperties } from "react";

const CORES = ["var(--gs-tinta)", "var(--gs-marca)", "var(--gs-sobre-tinta-2)"];

export function Confete({ pecas = 24 }: { pecas?: number }) {
  const lista = useMemo(
    () =>
      Array.from({ length: pecas }, (_, i) => ({
        esquerda: Math.random() * 100,
        atraso: Math.random() * 200,
        giro: 180 + Math.random() * 360,
        deriva: (Math.random() - 0.5) * 80,
        cor: CORES[i % CORES.length],
      })),
    [pecas],
  );
  return (
    <div data-confete aria-hidden className="pointer-events-none fixed inset-0 z-70 overflow-hidden">
      {lista.map((p, i) => (
        <span
          key={i}
          className="absolute top-0 block h-[14px] w-[6px]"
          style={
            {
              left: `${p.esquerda}%`,
              background: p.cor,
              clipPath: "polygon(0 0, 100% 29%, 100% 100%, 0 71%)",
              animation: `gs-confete var(--gs-dur-confete) var(--gs-curva-saida) ${p.atraso}ms both`,
              "--d": `${p.deriva}px`,
              "--g": `${p.giro}deg`,
            } as CSSProperties
          }
        />
      ))}
    </div>
  );
}
